import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { listApplications } from '../actions/applicationActions'

export default function Applications(props) {
    const dispatch = useDispatch()
    const applicationList = useSelector((state) => state.applicationList)
    const { loading, error, applications } = applicationList

    const [dealId2, setdealId2] = useState("")
    const contactId = props.contactId;
    const dealId = props.dealId;

    useEffect(() => {
        if (dealId != '') {
            if (applications == undefined || applications.length == 0 || dealId != dealId2) {
                dispatch(listApplications(contactId, dealId))
                setdealId2(dealId)
            }
        }
    }, [dispatch, applications, dealId])

    return (
        loading ? (
            <option value="0">loading...</option>
        ) : (
            applications ? (
                (applications.length > 0) ? (
                    applications.map(invtyp => (
                        <option value={invtyp.Id}>SED{invtyp.Id}</option>
                    ))
                ) : (
                    <option value="0">No Record Exist!</option>
                )
            ) : (
                <option value="0">{error}</option>
            )
        )
    )
}
